import CampaignAnalyticsContent from '@components/Dashboard/CampaignAnalytics/CampaignAnalytics';
import { useCurrentCampaign } from '../hooks/useCampaign';

export const CampaignAnalytics = () => {
  const { campaign } = useCurrentCampaign();

  if (!campaign) return null;

  return (
    <CampaignAnalyticsContent
      contentProps={{ padding: 0 }}
      campaignName={campaign.name}
      campaignId={campaign.id}
    />
  );
};
